import { Button, ButtonGroup } from '@frontend/components/common';
import React from 'react';

const ID = 'detail-actions-footer';

export interface DetailActionsFooterProps {
    buttons: Button[];
    actionsOverContent: boolean;
}

/**
 * Bottom-pinned, center-aligned action footer for mobile detail pages.
 * Frosted when content scrolls underneath; transparent when at the bottom.
 */
export const DetailActionsFooter = (props: DetailActionsFooterProps) => {
    return (
        <footer
            id={ID}
            className={`absolute bottom-0 z-30 flex w-full justify-center px-5 py-6 transition-[background-color,backdrop-filter,border-color] duration-200 ${
                props.actionsOverContent
                    ? 'border-border-default/40 bg-background-default/80 border-t backdrop-blur-md'
                    : 'border-t border-transparent bg-transparent'
            }`}>
            <ButtonGroup
                className='flex w-full flex-wrap items-center justify-center gap-3'
                buttons={props.buttons}
            />
        </footer>
    );
};

export default DetailActionsFooter;
